/**
 * 이미지 압축 — 가로·세로 모두 maxSize 박스 안에 맞추고 WebP로 변환
 * 프로필/학원 사진 등 썸네일 업로드용 (기본 400x400)
 */
export const compressImage = (file, maxSize = 400, quality = 0.8) => {
  return new Promise((resolve) => {
    if (!file || !file.type?.startsWith('image/')) { resolve(file); return; }
    const img = new Image();
    img.onload = () => {
      let w = img.width;
      let h = img.height;
      const scale = Math.min(1, maxSize / Math.max(w, h));
      w = Math.round(w * scale);
      h = Math.round(h * scale);
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      canvas.toBlob((blob) => {
        if (!blob) { resolve(file); return; }
        resolve(new File([blob], file.name.replace(/\.\w+$/, '.webp'), { type: 'image/webp' }));
      }, 'image/webp', quality);
    };
    img.onerror = () => resolve(file);
    img.src = URL.createObjectURL(file);
  });
};

/**
 * 상세 이미지 압축 (비율 유지, 최대 너비 제한)
 */
export const compressDetailImage = (file, maxWidth = 1000, quality = 0.75) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      let w = img.width;
      let h = img.height;
      if (w > maxWidth) {
        h = Math.round((h * maxWidth) / w);
        w = maxWidth;
      }
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      canvas.toBlob((blob) => {
        resolve(new File([blob], file.name.replace(/\.\w+$/, '.webp'), { type: 'image/webp' }));
      }, 'image/webp', quality);
    };
    img.src = URL.createObjectURL(file);
  });
};
